/**
 * Editorial placeholder "logo" for sponsors without a real image.
 * Cream bg + dashed border + Fraunces italic name + tiny tier eyebrow.
 */
export default function SponsorLogoPlaceholder({
  name,
  tier,
  tone = "light",
  size = "md",
  className = "",
}) {
  const ratioH = size === "lg" ? "h-16 md:h-20" : size === "sm" ? "h-10" : "h-14";
  const minW = size === "lg" ? "min-w-[240px]" : size === "sm" ? "min-w-[140px]" : "min-w-[180px]";
  const isDark = tone === "dark";
  const base = isDark
    ? "bg-cream/5 border-cream/25 text-cream/80"
    : "bg-cream border-charcoal/20 text-charcoal/75";
  const eyebrow = isDark ? "text-gold/80" : "text-terracotta/80";
  return (
    <div
      data-testid={`sponsor-placeholder-${(name || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={`${ratioH} ${minW} flex flex-col items-center justify-center px-4 border border-dashed rounded-sm ${base} ${className}`}
    >
      {tier && (
        <p className={`text-[9px] uppercase tracking-[0.22em] mb-0.5 leading-none ${eyebrow}`}>
          {tier}
        </p>
      )}
      <p className="font-serif italic text-[11px] md:text-xs leading-tight text-center truncate max-w-full">
        {name}
      </p>
    </div>
  );
}
